import React from 'react';
import {NotificationIcon} from '../../Icons';
import {Image} from '@learningblocks/shared-components';

export function DescriptionIcon() {
  return <Image alt='info' tabIndex={-1} src={NotificationIcon} />;
}
